module.exports = __webpack_public_path__ + "static/media/nvidia-logo.cb3285ce.png";


//////////////////
// WEBPACK FOOTER
// ./public/nvidia-logo.png
// module id = 299
// module chunks = 0